module.exports = __webpack_public_path__ + "media/images/questionnaire_overview/people-3fd1d8836df743b5822bb41737d2ded6.svg";